import {
  type ConfirmationModalProps,
  type MenuItemProps,
  ConfirmationModal,
  MenuItem,
} from '@shared/components';
import { useState } from 'react';

interface MenuItemWithConfirmationProps extends Omit<MenuItemProps, 'content'> {
  onAccept: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  onClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  onDiscard: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  title: string;
  content: React.ReactNode;
  acceptText: string;
  discardText: string;
  variant?: ConfirmationModalProps['variant'];
}

export default function MenuItemWithConfirmation(props: Readonly<MenuItemWithConfirmationProps>) {
  const [isOpen, setIsOpen] = useState(false);
  const {
    acceptText,
    children,
    content,
    discardText,
    title,
    variant,
    onAccept,
    onClick,
    onDiscard,
    ...restProps
  } = props;

  const handleClick = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    event.stopPropagation();
    setIsOpen(true);
    onClick?.(event);
  };

  const handleAccept = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.stopPropagation();
    onAccept?.(event);
    setIsOpen(false);
  };

  const handleDiscard = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    event.stopPropagation();
    onDiscard?.(event);
    setIsOpen(false);
  };

  return (
    <>
      <MenuItem onClick={handleClick} {...restProps}>
        {children}
      </MenuItem>
      <ConfirmationModal
        open={isOpen}
        title={title}
        content={content}
        acceptText={acceptText}
        discardText={discardText}
        onDiscard={handleDiscard}
        onAccept={handleAccept}
        variant={variant}
        maxWidth='xs'
      />
    </>
  );
}
